import { Collapse } from '@mui/material';
import { FC } from 'react';
import { useSnapshot } from 'valtio';
import { closeWhatsNew } from '../actions/whats-new-close-action';
import WhatsNew from '../components/WhatsNew';
import WhatsNewStore from '../stores/whats-new-store';

const WhatsNewContainer: FC = () => {
  const { items, dismissable } = useSnapshot(WhatsNewStore);

  return (
    <Collapse in={items.length > 0} orientation='vertical'>
      <WhatsNew
        items={items}
        onClose={closeWhatsNew}
        dismissable={dismissable}
      />
    </Collapse>
  );
};

export default WhatsNewContainer;
